import { GridFilterItem, GridFilterModel, GridLogicOperator } from '@mui/x-data-grid';

export interface FilterItem extends GridFilterItem {
    from?: string | number | Date;
    to?: string | number | Date;
}
export interface DateRangeDetails {
    field: string;
    fromDate: string | Date | null;
    toDate: string | Date | null;
}

export interface SingleValueDetails {
    field: string;
    value: string | null;
}

export interface MultiValueDetails {
    field: string;
    values: string[];
}

export function buildFilters(
    dateRangeDetails?: DateRangeDetails,
    singleValueDetails?: SingleValueDetails,
    multiValueDetails?: MultiValueDetails
): FilterItem[] {
    const filters: FilterItem[] = [];

    if (dateRangeDetails && dateRangeDetails.fromDate && dateRangeDetails.toDate) {
        filters.push({
            field: dateRangeDetails.field,
            operator: 'equals',
            from: dateRangeDetails.fromDate,
            to: dateRangeDetails.toDate,
        });
    }

    if (singleValueDetails && singleValueDetails.value) {
        filters.push({
            field: singleValueDetails.field,
            operator: 'equals',
            value: singleValueDetails.value,
        });
    }

    if (
        multiValueDetails &&
        Array.isArray(multiValueDetails.values) &&
        multiValueDetails.values.length > 0
    ) {
        multiValueDetails.values.forEach((value: string) => {
            filters.push({
                field: multiValueDetails.field,
                operator: 'equals',
                value,
            });
        });
    }

    return filters;
}

export function createFilterObject(items: GridFilterItem[]): GridFilterModel {
    return {
        items,
        logicOperator: GridLogicOperator.And,
    };
}
